import ApiService from '@/services/api.service'

const TransferService = {
    AddTransfer(transfer){
        return ApiService.post(`/ProgramTransfers`, transfer);
    },    
  }
  
  export default TransferService;